// removed by extract-text-webpack-plugin
module.exports = {"content":"Content__content___3rZyU"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/common/content/Content.scss
// module id = 1985
// module chunks = 0